import { axiosConfigs } from 'tradera/utils/api';
import qs from 'qs';
import {
    webApiClient,
    shippingRecommendationsClient
} from 'tradera/utils/http';

export const getShippingProvidersByWeight = (
    fromCountry,
    charityId,
    itemId
) => {
    const params = {
        fromCountryCode: fromCountry,
        charityId,
        itemId
    };

    return webApiClient.get(
        `/selling/shipping-products-for-country-by-weight-span?${qs.stringify(
            params
        )}`,
        axiosConfigs.authenticated
    );
};

export const getShippingRecommendations = (categoryId) =>
    shippingRecommendationsClient.query(
        `GetCategoryShippingRecommendations?CategoryId=${categoryId}`
    );
